import React from 'react';
import { render } from 'react-dom';
import PFramesApp from './components/pframe';

const frames_el = document.getElementById('pframes-app');

if (frames_el) {
  const attrs = frames_el.attributes;
  render(<PFramesApp {...{ attrs }} />, frames_el);
}
